import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages: {
	[key: string]: MessageDescriptor;
} = defineMessages({
	manageRoles: {
		id: 'users-and-roles.header.manage-roles.manage-roles',
		defaultMessage: 'Manage roles',
		description: 'Text on the button in the page header which allows the user to manage roles',
	},
	manageRolesFreeTooltip: {
		id: 'users-and-roles.header.manage-roles.manage-roles-free-tooltip',
		defaultMessage:
			"Project roles aren't editable in Jira {product} Free. Upgrade for advanced team configuration",
		description:
			'Tooltip shown to users on the free plan when they hover over the "Manage Roles" button',
	},
	manageRolesJswFreeTooltip: {
		id: 'users-and-roles.header.manage-roles.manage-roles-jsw-free-tooltip',
		defaultMessage:
			"On a free plan, you can't edit or customize this project's roles or permissions. Upgrade your plan to better control who can access this project.",
		description:
			'Tooltip shown to users on the free plan when they hover over the "Add people" button',
	},
	manageRolesJsmFreeTooltip: {
		id: 'users-and-roles.header.manage-roles.manage-roles-jsm-free-tooltip',
		defaultMessage:
			"On a free plan, you can't edit or customize this service project's roles or permissions. Upgrade your plan to better control who can access this service project.",
		description:
			'Tooltip shown to users on the free plan when they hover over the "Add people" button',
	},
});

export default messages;
